$(document).ready(function() {

  $(".numbersOnly").keypress(function(e) {
    var charCode = e.which;
    var charStr = String.fromCharCode(charCode);
    if (!$.isNumeric(charStr) && ![0, 8, 9, 13, 27, null].includes(charCode)) e.preventDefault();
  });

  // Autopopulate zipCode input field from cookie or Maxmind lookup
  if ($("[name='zipCode']").length) {
    var zipCode = Cookies.get("zipCode");
    if (zipCode) {
      $("[name='zipCode']").val(zipCode);
    }else {
      // Autopopulate Zipcode from Maxmind Lookup
      $.getScript("//js.maxmind.com/js/apis/geoip2/v2.1/geoip2.js", function () {
        geoip2.city(function (location) {
          var zipCode = location && location.postal && location.postal.code;
          if (zipCode && /\d{5}/.test(zipCode)) {

            window.eventQueue = window.eventQueue || [];
            window.eventQueue.push({
              "eventType": "autopopSuccess",
              "eventData": {
                "zip": zipCode
              }
            });

            // Autopopulate
            $("[name='zipCode']").val(zipCode);
            Cookies.set("zipCode", zipCode);

          } else {
            window.eventQueue = window.eventQueue || [];
            window.eventQueue.push({
              "eventType": "autopopFail"
            });
          }
        });
      });
    }
  }

  // Autopopulate zipCode link from cookie or Maxmind lookup
  if ($(".predictive-routing-link").length) {
    if (Cookies.get("zipCode")) {

      $(".predictive-routing-link").attr("href", getPredictiveUrl(Cookies.get("zipCode")));
    } else {

      // Autopopulate Zipcode from Maxmind Lookup
      $.getScript("//js.maxmind.com/js/apis/geoip2/v2.1/geoip2.js", function () {
        geoip2.city(function (location) {
          var zipCode = location && location.postal && location.postal.code;
          if (zipCode && /\d{5}/.test(zipCode)) {

            window.eventQueue = window.eventQueue || [];
            window.eventQueue.push({
              "eventType": "autopopSuccess",
              "eventData": {
                "zip": zipCode
              }
            });

            Cookies.set("zipCode", zipCode);
            $(".predictive-routing-link").attr("href", getPredictiveUrl(zipCode));

          } else {
            window.eventQueue = window.eventQueue || [];
            window.eventQueue.push({
              "eventType": "autopopFail"
            });

            $(".modal-overlay .close-modal").click(function () {
              closeMPModal();
            });

            $("[data-product-name='Auto']").click(function (event) {
              event.preventDefault();
              openMPModal();
            });

            alert("ZIP NOT FOUND!");
          }
        });
      });
    }
  }

  // hide input errors on blur if field is valid
  $(document).on("change", ".show-error input, .show-error select, .show-error textarea", function() {
    validateField($(this));
  });

  $("form").submit(function(e) {
    e.preventDefault();
    var $form = $(this);

    if (validateForm($form)) {

      // Initial Zipcode
      if($form.is(".initial-zipcode")) {
        addCPAAgentCode = $form.is('#cpa');

        var zip = $form.find("[name='zipCode']").val();
        Cookies.set("zipCode", zip);

        window.eventQueue = window.eventQueue || [];
        window.eventQueue.push({
          "eventType": "zipFormSubmitted",
          "eventData": {
            "zip": zip
          }
        });

        Cookies.set("quoteStart", "true", {
          domain: "good2go.com"
        });

        //Promedia Pixel
        pmpx("event", "form_fill", {zip_code: zip});

        var redirectURL = getPredictiveUrl(zip);
        window.setTimeout(function () {
          window.location.href = redirectURL;
        }, 250);
      }

      // Retrieve Quote
      if ($form.is("#retrieveQuote")) {
        var formType = $form.data("form-type");
        var lastName = $form.find("[name='lastName']").val();
        var quoteNumber = $form.find("[name='quoteNumber']").val();
        var zipCode = $form.find("[name='zipCode']").val();
        var birthDate = $form.find("[name='birthDate']").val();
        var email = $form.find("[name='email']").val();

        var quoteLookupHostname = "https://devquote.good2go.com"; //TODO: dynamic based on hostname
        var quoteLookupPath = "/Webservices/QuoteLookup.ashx";
        var quoteLookupSearch = "?quoteNumber=" + quoteNumber + "&lastName=" + lastName + "&zipCode=" + zipCode + "&emailaddress=" + email + "&birthdate=" + birthDate;

        if(formType === "quoteNumber") {
          quoteLookupSearch += "&lookupType=1";
        }else if(formType === "emailAndBirthdate") {
          quoteLookupSearch += "&lookupType=2";
        }

        var quoteLookupURL = encodeURI(quoteLookupHostname + quoteLookupPath + quoteLookupSearch);

        //TODO: verify when environemnt is back up
        $.ajax({
          crossDomain: true,
          contentType: "application/json; charset=utf-8",
          url: quoteLookupURL,
          dataType: "jsonp",
          success: function(data) {
            var isSuccess = data.status == 1;
            if (isSuccess) {
              var redirectURL = data.url;
              Cookies.set("quoteRetrieve", quoteNumber + "|" + zipCode, { domain: "good2go.com" });
              window.location.href = redirectURL;
            } else {
              if (data.message == "Quoteissued") {
                $("#lblmsg").text("A policy has already been issued for this quote number.");
                $("#lblmsg-container").show();
              } else {
                $("#lblmsg").text("We are unable to retrieve your quote based upon the information entered. Please contact us at 855-646-4661 for assistance.");
                $("#lblmsg-container").show();
              }
            }
          },
          error: function(data) {
            $("#lblmsg").text("We are unable to retrieve your quote based upon the information entered. Please contact us at 855-646-4661 for assistance.");
            $("#lblmsg-container").show();
          }
        });
      }
    }
  });
});

function validateForm($form) {
  var $fields = $form.find("input:visible, select:visible, textarea:visible");
  $.each($fields, function (key, input) {
    var $input = $(input);
    validateField($input);
  });

  if (!$form.find(".show-error").length) {
    return true;
  }
}

function validateField($field) {
  var regexes = {
    "address": /^[a-zA-Z0-9\s\.\,\(\)\/\-#]*$/,
    "any": /[\s\S]*/,
    "currency": /^\$[0-9,]*$/,
    "dateShort": /((0[1-9])|(1[0-2]))[\/]((0[1-9])|(1[0-9])|(2[0-9])|(3[0-1]))/,
    "dateLong": /((0[1-9])|(1[0-2]))[\/]((0[1-9])|(1[0-9])|(2[0-9])|(3[0-1]))[\/](\d{4})/,
    "email": /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    "initial": /[A-z]/,
    "name": /^[a-zA-Z\s]*$/,
    "percentage": /^\d{0,2}(\.\d{1,4})? *%?$/,
    "phone": /^[0-9]{10}$/,
    "search": /^(?!\s*$).+/,
    "years": /^\d{0,2} *(year[s]?)?$/,
    "zipCode": /^\d{5,6}(?:[-\s]\d{4})?$/,
    "quoteNumber": /^\d{7,8}$/
  };
  var isInvalid = false;
  var inputType = $field.attr("data-input-type");
  var value = $field.val();
  var isRequired = $field.attr("required");

  if (value || (!value && isRequired)) {
    if ($field.is("select")) {
      isInvalid = value == "";
    } else {
      isInvalid = !new RegExp(regexes[inputType]).test(value) || value == "";
    }
  }

  // Check Invalid Zip
  if (inputType === "zipCode" && window.invalidZipCodes && window.invalidZipCodes.indexOf(value) != -1) isInvalid = true;

  if (isInvalid) {
    $field.closest(".form-element").addClass("show-error");
    $field.attr("aria-invalid", "true");
  } else {
    $field.closest(".form-element").removeClass("show-error");
    $field.attr("aria-invalid", "false");
  }
}

function getPredictiveUrl(zip) {
  var leadHostname = "http://dev.leads.goodtogoquote.com/switch/survey_route";
  if (location.hostname == "awsstaging.good2go.com" || location.hostname == "staging.good2go.com") leadHostname = "http://staging.leads.goodtogoquote.com/switch/survey_route";
  if (location.hostname == "direct.good2go.com" || location.hostname == "www.good2go.com") leadHostname = "http://leads.goodtogoquote.com/switch/survey_route";

  // Configure params for redirectUrl
  var source = getLastTouchCampaignSource();
  var medium = getLastTouchCampaignMedium();
  var campaign = getLastTouchCampaignName();
  var content = getLastTouchCampaignContent();
  var tid = getURLParameter("tid");
  var gclid = getURLParameter("gclid");

  // Get GA Visitor ID
  var uri_sourceMedium = encodeURIComponent(source + " / " + medium);
  var uri_visitorId = encodeURIComponent(getGAVisitorId());
  var uri_campaign = encodeURIComponent(campaign);
  var uri_content = encodeURIComponent(content);

  // Create Final Redirect URL
  var redirectUrl = leadHostname + "?zipcode=" + zip + "&source_medium=" + uri_sourceMedium + "&ga_visitor_id=" + uri_visitorId + "&_ga=" + uri_visitorId;
  if (uri_campaign) redirectUrl += "&utm_campaign=" + uri_campaign;
  if (uri_content) redirectUrl += "&utm_content=" + uri_content;
  if (tid) redirectUrl += "&tid=" + tid;
  if (gclid) redirectUrl += "&eq-gclid=" + gclid;
  if (addCPAAgentCode) redirectUrl += "&agent_code=900052";

  return redirectUrl;
}

function closeMPModal() {
  if ($(".modal-overlay").css('display') != "none") {
    $(".modal-overlay").css("display", "none");
  }
}
function openMPModal() {
  if ($(".modal-overlay").css('display') == "none") {
    $(".modal-overlay").css("display", "block");
  }
}